import React from "react";
import {
  Box,
  Button,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import type {
  ClientUser,
} from "../api/clientManagement";

interface UserRowProps {
  user: ClientUser;
  statusLabel: string;
  statusTone: "success" | "muted";
  onOpenEdit: () => void;
}

export const UserRow: React.FC<UserRowProps> = ({
  user,
  statusLabel,
  statusTone,
  onOpenEdit,
}) => (
  <TableRow hover onClick={onOpenEdit} sx={{ cursor: "pointer" }}>
    <TableCell>
      <Stack spacing={0.25}>
        <Typography variant="body2" fontWeight={600}>
          {user.first_name} {user.last_name}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {user.email}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Click row to edit
        </Typography>
      </Stack>
    </TableCell>
    <TableCell>
      <Typography variant="body2" color="text.secondary">
        {user.departments.length
          ? user.departments.map((dept) => dept.name).join(", ")
          : "-"}
      </Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2" color="text.secondary">
        {user.job_roles.length
          ? user.job_roles.map((role) => role.name).join(", ")
          : "-"}
      </Typography>
    </TableCell>
    <TableCell>
      <Stack spacing={1}>
        {SERVICE_LABELS.map((service) => (
          <Typography key={service.key} variant="caption" color="text.secondary">
            {service.label}: {user.enabled_services?.[service.key] ? "Enabled" : "Disabled"}
          </Typography>
        ))}
      </Stack>
    </TableCell>
    <TableCell>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          px: 1,
          py: 0.5,
          borderRadius: 999,
          fontSize: 12,
          fontWeight: 600,
          color: statusTone === "success" ? "success.dark" : "text.secondary",
          backgroundColor:
            statusTone === "success"
              ? "rgba(46, 125, 50, 0.12)"
              : "action.selected",
        }}
      >
        {statusLabel}
      </Box>
    </TableCell>
    <TableCell>
      <Button
        variant="text"
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          onOpenEdit();
        }}
      >
        Edit
      </Button>
    </TableCell>
  </TableRow>
);

const SERVICE_LABELS = [
  { key: "learning_locker", label: "Learning Locker" },
  { key: "occupational_health", label: "Occupational Health" },
  { key: "wearables", label: "Wearables" },
  { key: "akea_life", label: "Akea Life" },
] as const;
